package com.anjuros.website.redesign.components

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.styles.RdInlineLinkStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Em
import org.jetbrains.compose.web.dom.Text

/** Bold "{b}…{/b}", italic "{i}…{/i}" and links "<a href="…">…</a>", the markup used in the blog texts. */
private val RichMarkup = Regex("""\{b\}(.*?)\{/b\}|\{i\}(.*?)\{/i\}|<a\s+href="([^"]+)">(.*?)</a>""")

/** Inline text with the blog markup turned into bold, italic and links (site links stay in the app). */
@Composable
fun RdRichText(text: String) {
    var last = 0
    RichMarkup.findAll(text).forEach { match ->
        if (match.range.first > last) Text(text.substring(last, match.range.first))
        val (bold, italic, href, linkText) = match.destructured
        when {
            bold.isNotEmpty() -> B { Text(bold) }
            italic.isNotEmpty() -> Em { Text(italic) }
            href.startsWith("http") -> RdExternalLink(href, RdInlineLinkStyle.toModifier()) { Text(linkText) }
            else -> RdLink(href, RdInlineLinkStyle.toModifier()) { Text(linkText) }
        }
        last = match.range.last + 1
    }
    if (last < text.length) Text(text.substring(last))
}

/** The text without its markup, for places that need plain text such as structured data. */
fun rdPlainText(text: String): String =
    text.replace(Regex("""<a\s+href="[^"]+">(.*?)</a>"""), "$1").replace(Regex("""\{/?[bi]\}"""), "")

/** True when the text is nothing but one link, which articles show as a "learn more" card. */
fun isOnlyLink(text: String): Boolean = Regex("""^\s*<a\s+href="[^"]+">.*?</a>\s*$""").matches(text)
